// Dev-only balance tuning knobs (16.65, Don's direction) -- live-adjustable
// via sliders in the Options screen (behind the existing DEV DEBUG toggle),
// not part of AppState/GameSaveData: these are a development aid for
// iterating on balance, not a captain-facing setting or save.
export interface DevTuning {
  // Small hull's own Fast Travel fuel cost (16.50's "10 fuel" base unit) --
  // every other hull size's Fast Travel/Warp cost, and every hull's tank
  // capacity, derives from this.
  fuelBaseCost: number;
  // Provisions consumed per crew member per real-clock-hour (Section 11's
  // "1 Provision supports 10 crew for 1 hour" baseline = 0.1/crew/hour).
  provisionsPerCrewPerHour: number;
  // Fuel tank capacity scales independently of (faster than) consumption
  // rate (16.65): capacityMultiplier = rateMultiplier ^ this exponent.
  // 1.0 degrades to "same endurance for every hull size"; higher widens
  // the gap so bigger hulls get more range, not just a bigger absolute
  // number at the same jump count.
  fuelCapacityScalingExponent: number;
}

export const devTuning: DevTuning = {
  fuelBaseCost: 10,
  provisionsPerCrewPerHour: 0.1,
  fuelCapacityScalingExponent: 1.3
};

export function resetDevTuning(): void {
  devTuning.fuelBaseCost = 10;
  devTuning.provisionsPerCrewPerHour = 0.1;
  devTuning.fuelCapacityScalingExponent = 1.3;
}
